import { EventFunctions } from '@/enums/eventFunctions.enum';
import { TableName } from '@/enums/tableName.enum';
import store from '@/store/store';
import { tryParseInt } from '@/utils/number';
import { getTimePeriod, getToday } from '@/utils/time';
import TeamProfile from '@/views/team/tabs/Details.vue';

export const teamDetailsRoute = {
  path: '',
  name: 'team',
  component: TeamProfile,
  meta: { title: 'titles.team.details' },
  beforeEnter: (to: any, from: any, next: any) => {
    const teamId = tryParseInt(to.params.teamId);

    const permissions = [`USER.LIST:${TableName.Team}:${teamId}`, `TEAM.EVENTS:${TableName.Team}:${teamId}`];

    store.dispatch('auth/checkPermissions', permissions).then(res => {
      if (permissions.every(permission => !!res[permission])) {
        const today = getToday();
        const timePeriod = getTimePeriod('day', today.year, today.month, today.day);

        Promise.all([
          store.dispatch('events/list', {
            id: teamId,
            eventType: EventFunctions[TableName.Team],
            start: timePeriod.start,
            end: timePeriod.end
          }),
          store.dispatch('team/player/list', { teamId }),
          store.dispatch('team/coach/list', { coachedTeamId: teamId })
        ])
          .then(() => next())
          .catch(() => store.dispatch('notifyError', { title: 'messages.event.error' }));
      } else {
        next();
      }
    });
  }
};
